import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../services/session2.service';

@Component({
  selector: 'settings-nav',
  templateUrl: './settings-nav.component.html'
})
export class SettingsNavComponent implements OnInit {

  labsAccess = false;
  botAccess = false;
  emailsThroughDrift = false;
  constructor(private sessionService: SessionService) { }

  ngOnInit() {
    this.sessionService.getSession().subscribe(
      (result: any) => {
        this.labsAccess = result.f.labs;
        this.botAccess = result.f.bot;
        this.emailsThroughDrift = result.f.emailsThroughDrift;
      }
    );
  }
}

@Component({
  selector: 'settings-nav-dropdown',
  templateUrl: './settings-nav-dropdown.component.html'
})
export class SettingsNavDropdownComponent implements OnInit {

  labsAccess = false;
  botAccess = false;

  activeView:string = '';

  constructor(private router: Router,
              private route: ActivatedRoute,
              private sessionService:SessionService) { }

  ngOnInit() {
    this.activeView = this.route.snapshot.data['uiTitle'];

    this.sessionService.getSession().subscribe(
      (result: any) => {
        this.labsAccess = result.f.labs;
        this.botAccess = result.f.bot;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/settings/settings-nav/settings-nav.component.ts